// Filename: index.ts
import Alpine from 'alpinejs';
import bootstrap from "bootstrap";
import SearchFilterManager from '@js/managers/SearchFilterManager';
import JobLoadingManager, {
    initializeJobPayloadControls,
    refreshJobPayloadControls,
} from '@js/managers/JobLoadingManager';
import { initializeInfiniteSearchResults } from '@js/managers/InfiniteSearchResultsManager';
import SearchBarManager from '@js/managers/SearchBarManager';
import { initializeJobSharing } from '@js/managers/JobSharingManager';
import { initializeJobMaps } from './JobMap';
console.log("Partner-Site-Board-Index Loaded");
// Register Alpine.js data components

document.addEventListener('alpine:init', () => {
    console.log("Alpine Partner-Site-Board-Index Loaded");
    Alpine.data('SearchFilterManager', SearchFilterManager);
    Alpine.data('SearchBarManager', SearchBarManager);
    const jobLoadingManager = JobLoadingManager();
    Alpine.store('JobLoadingManager', jobLoadingManager);
    initializeJobPayloadControls(jobLoadingManager);
    initializeJobSharing();
    initializeInfiniteSearchResults({
        afterAppend: () => refreshJobPayloadControls(),
    });
});

// Start Alpine.js
//@ts-ignore
Alpine.start();

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeJobMaps());
else initializeJobMaps();
